// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1LkQ4","footer":"ModalError_footer__1gDF3"};